let mostRequested = document.querySelector('#most-requested item');

mostRequested?.addEventListener('mouseenter', function(){
    this.classList.add('active');
})

mostRequested?.addEventListener('mouseleave', function(){
    this.classList.remove('active');
})

